<template>
    <div class="wrap wrap--main" v-if="loading">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">

            <!-- 비주얼 배너 -->
            <main-banners code="main-pc" pc></main-banners>
            <main-banners code="main-mobile" mobile></main-banners>
            <!-- 베스트 주거공간 -->
            <main-best-space></main-best-space>
            <!-- 부분인테리어 PICK -->
            <main-partial-pick :category_id="findID('부분시공')"></main-partial-pick>
            <!-- 베스트 상업공간 -->
            <main-best-space :category_id="findID('상업공간')"></main-best-space>

            <div class="main-section main-section--review">
                <div class="inner">
                    <div class="main-review-area">
                        <div class="main-review-left">
                            <h3 class="title">리얼 <b>고객 후기</b></h3>
                            <div class="img"><img src="/images/main/main-review-image.png" alt=""></div>
                        </div>
                        <div class="main-review-right">
                            <!-- 후기 슬라이드 -->
                            <main-review></main-review>
                        </div>
                    </div>
                </div>
            </div>

            <main-before-after></main-before-after>

            <div class="main-section">
                <div class="inner">
                    <div class="ban-grid-container">
                        <div class="grid">
                            <div class="grid-12">
                                <!-- 배너 : PC 좌측 -->
                                <main-banners-grid code="lower-left"></main-banners-grid>
                            </div>
                            <div class="grid-12">
                                <!-- 배너 : PC 우측 -->
                                <main-banners-grid code="lower-right"></main-banners-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import api from "@/api";
import MainHeader from '@/components/client/inc/main-header.vue';
import MainFooter from '@/components/client/inc/main-footer.vue';
import MainBanners from "@/components/client/main/main-banners.vue";
import MainBestSpace from "@/components/client/main/main-best-space.vue";
import MainPartialPick from "@/components/client/main/main-partial-pick";
import MainReview from "@/components/client/main/main-review";
import MainBeforeAfter from "@/components/client/main/main-before-after";
import MainBannersGrid from "@/components/client/main/main-banners-grid.vue";
export default{
    components: {
        MainHeader,
        MainFooter,
        MainBanners,
        MainBestSpace,
        MainPartialPick,
        MainBeforeAfter,
        MainReview,
        MainBannersGrid,
    },
    data() {
        return {
            loading : false,

            categories : null
        }
    },
    mounted() {
        this.init();
    },
    methods : {
        findID(name) {
            for (var i = 0; i < this.categories.length; i++) {
                if(this.categories[i].name == name) return this.categories[i]._id;
            }
        },
        async init() {
            try {
                var { categories } = await api.v1.portfolios.categories.getCategories();
                this.categories = categories;
                this.loading = true;
            }catch(error) {
                console.error(error);
            }
        },
    }
}
</script>